'use strict';
import axios from "axios";
import Configuration from "@/Common/Configuration";
import Utility from "@/Common/Utility";
import apiService from '@/Common/ApiService';
import FormViewRequest from '@/Common/FormViewRequest';
 

function ShoppingCart() {


    this.ShoppingCartId = ShoppingCart.GenerateShoppingCartId();
    this.Products = [];

    //寄件人
    this.CustomerNo = 0;
    this.CustomerName = "";
    this.CellPhoneNumber = "";
    this.Email = "";
    this.RegionName = "";
    this.CityName = "";
    this.Street = "";
    this.ZipCode = "";

    //收件人
    this.ReceiverIsOrderer = true;//收件人同訂購人
    this.ReceiverName = "";
    this.ReceiverCellPhoneNumber = "";
    this.ReceiverEmail = "";
    this.ReceiverRegionName = "";
    this.ReceiverCityName = "";
    this.ReceiverStreet = "";
    this.ReceiverZipCode = "";

    //訂單附註
    this.OrderDescription = "";

    //預設付款方式　無
    this.PaymentMethod = "";

    this.ProductTotalAmount = 0;
    this.HandlingFee = 0;
    this.ShippingPrice = 0;

    this.RewardPointsDiscountAmount = 0;

    this.CouponId = "";
    this.CouponAmount = 0;//折價卷可折抵金額
    this.CouponDiscountTotalAmount = 0;

    this.NplCouponId = "";
    this.NplCouponNo = null;
    this.NplCouponDiscountTotalAmount = 0;

    this.SourceNplCouponDiscountAmount = 0;

    this.MemberGradeAmount = 0;//會員等級折抵金額 

    this.AmountPayable = 0;//總金額

    this.BillNo = null;//繳費單編號

    this.CallbackUrl = null;//付款成功 返回處
}


function ShoppingCartProduct() {
    this.ProductNo = 0;
    this.ProductId = "";
    this.ProductName = "";
    this.ProductVariationNo = 0;
    this.ProductCount = 1;
    this.UnitPrice = 0;
    this.UnitName = "";

    this.DeliveryType = "";
    this.CombinationType = "";
}


ShoppingCart.GenerateShoppingCartId = function () {
    let shoppingCartId = "";
    let currDate;

    currDate = new Date();

    shoppingCartId += (currDate.getFullYear() + "").substr(2,2) +
                      (currDate.getMonth() + 1 + "").padStart(2, 0) +   (currDate.getDate() + "").padStart(2, 0);

    shoppingCartId += ""+ (currDate.getHours() + "").padStart(2, 0) +
        (currDate.getMinutes() + "").padStart(2, 0) ;

    //shoppingCartId += "_" + (currDate.getSeconds() + "").padStart(2, 0);
 
    shoppingCartId += "S" + (Math.round(Math.random() * 1000000) + "").padStart(6, 0);

    return shoppingCartId;
};


ShoppingCart.ConvertShoppingCartToOrder = function (shoppingCartId) {
    let listViewRequest;
    let shoppingCartJson;
    let shoppingCart = {};
    let formViewRequest = {};
    let topVue;
    let i;

    debugger;

    topVue = window["TopVue"];

    if (Utility.GetSession("ShoppingCart") == null) {

        if (Utility.GetBag("ShoppingCartJson") != null) {
            shoppingCartJson = Utility.GetBag("ShoppingCartJson");

            if (shoppingCartJson != "undefined" && shoppingCartJson != "" && shoppingCartJson != null) {
                shoppingCart = JSON.parse(shoppingCartJson);

                Utility.SaveSession("ShoppingCart", shoppingCart);
            }
            else {
                alert("ShoppingCart is not exists !");
                return;
            }
        }
        else {
            alert("ShoppingCart is not exists !");
            return;
        }
    }

    shoppingCart = Utility.GetSession("ShoppingCart");

    if (shoppingCartId != null) {
        shoppingCart.ShoppingCartId = shoppingCartId;
    }

    formViewRequest = new FormViewRequest();

    formViewRequest.Rows = [];

    Object.assign(formViewRequest.ValueSet, shoppingCart);

    formViewRequest.ValueSet.CustomerNo = Utility.GetBag("CustomerNo");

    formViewRequest.ValueSet.Products = null;

    for (i = 0; i < shoppingCart.Products.length; i++) {
        let row = {};

        row.ValueSet = {};
        row.ValueSet = shoppingCart.Products[i];

        if (row.ValueSet.ProductVariationNo == null) {
            alert("row.ValueSet.ProductVariationNo is null !");
            throw ("row.ValueSet.ProductVariationNo is null !");
        }

        formViewRequest.Rows.push(row);
    }


    Utility.ShowLoadingPicture(topVue);

    return new Promise(
        (resolve, reject) => {
            apiService.Post("/api/ShoppingCart/ConvertShoppingCartToOrder", formViewRequest)
                .then(
                    function (responseData) {
                        Utility.HideLoadingPicture(topVue);

                        this.ValueSet = {};
                        Object.assign(this.ValueSet, responseData.ValueSet);


                        Utility.SaveBag("LastOrderNo", responseData.ValueSet.OrderNo);

                        Utility.ClearSession("ShoppingCart");
                        Utility.ClearBag("ShoppingCartJson");

                        resolve(responseData.ValueSet.OrderNo);

                        
                        window["vueComponent"].$bus.$emit("ShoppingCartChanged");
                    }.bind(this)
                ).catch(
                    (error) => {
                        Utility.HideLoadingPicture(this);

                        alert(error);
                        reject(error);
                    }
               );
        }
    );

};


ShoppingCart.AddProduct = function (product, billNo, callbackUrl) {
    let listViewRequest;
    let shoppingCartJson;
    let shoppingCart = {};
    let formViewRequest = {};
    let topVue;
    let existingProduct;
    let i;

     
    topVue = window["TopVue"];

    if (Utility.GetSession("ShoppingCart") == null) {

        if (Utility.GetBag("ShoppingCartJson") != null) {
            shoppingCartJson = Utility.GetBag("ShoppingCartJson");

            if (shoppingCartJson != "undefined" && shoppingCartJson != "" && shoppingCartJson != null) {
                shoppingCart = JSON.parse(shoppingCartJson);

                Utility.SaveSession("ShoppingCart", shoppingCart);
            }
            else {
                shoppingCart = new ShoppingCart();
                Utility.SaveSession("ShoppingCart", shoppingCart);
            }
        }
        else {
            shoppingCart = new ShoppingCart();
            Utility.SaveSession("ShoppingCart", shoppingCart);
        }
    }

 
    shoppingCart = Utility.GetSession("ShoppingCart");

    if (billNo != null) {
        shoppingCart.BillNo = billNo;
    }

    if (callbackUrl != null) {
        shoppingCart.CallbackUrl = callbackUrl;
    }

    if (shoppingCart.Products == null) {
        shoppingCart.Products = [];
    }

    existingProduct = shoppingCart.Products.find(
        p => p.ProductNo == (product.ProductNo  )
    );

 
    product.SubMenuData = null;
    product.PagePathData = null;
    product.DetailScript = null;
    product.DetailStyle = null;
    product.DetailTemplate = null;

    if (product.IsGift == null) {
        product.IsGift = false;
    }

    if (existingProduct != null) {
        existingProduct.ProductCount = product.ProductCount;
    }
    else {
        shoppingCart.Products.push(product);
    }

    delete shoppingCart.Bag  ;

    Utility.SaveSession("ShoppingCart", shoppingCart); 
    Utility.SaveBag("ShoppingCartJson", JSON.stringify(shoppingCart));
     
}



ShoppingCart.GetProductTotalAmount = function () {
    let totalAmount = 0;
    let row;
    let i;


      for (i = 0; i < this.Products.length; i++) {
         row = this.ShoppingCart.Products[i];
         totalAmount += row.UnitPrice * row.ProductCount;
     }
 
    return totalAmount;
}


export {
        ShoppingCartProduct,
        ShoppingCart
}

export default ShoppingCart;

